<template>
  <table v-if="loading" class="table table-borderless table-align">
    <thead>
      <tr>
        <th>CNPJ</th>
        <th>Razão Social</th>
        <th>Quantidade</th>
        <th>Valor total</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="item in 5" :key="item.index">
        <td class="pt-2">
          <Skeleton />
        </td>
        <td class="pt-2">
          <Skeleton animation-duration="2s" />
        </td>
        <td class="pt-2">
          <Skeleton animation-duration="1.5s" />
        </td>
        <td class="pt-2">
          <Skeleton col="10" />
        </td>
      </tr>
    </tbody>
  </table>

  <table v-else-if="companies.length" class="table table-borderless table-align">
    <thead>
      <tr>
        <th>CNPJ</th>
        <th>Razão Social</th>
        <th>Quantidade</th>
        <th>Valor total</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(company, index) in companies" :key="company.id">
        <td :class="buildClass(index + 1)">
          <span :class="getBadgeClass(index + 1)" class="badge badge-pill mr-2">
            {{ index + 1 }}
          </span>
          {{ company.cnpj | cnpj }}
        </td>
        <td>{{ company.name }}</td>
        <td>{{ company.count }}</td>
        <td>{{ company.sum | price }}</td>
        <td>
          <router-link :to="link(company.cnpj)">
            <button class="btn btn-sm btn-primary mr-2 float-right">Detalhes</button>
          </router-link>
        </td>
      </tr>
    </tbody>
  </table>

  <div v-else class="mt-4 text-center">
    Não foi encontrado nenhum CNPJ
  </div>
</template>

<script>
import Skeleton from '@/components/utils/Skeleton.vue';

export default {
  components: { Skeleton },
  computed: {
    companies() {
      return this.data || []
    }
  },
  methods: {
    buildClass(index) {
      return {
        '1': 'marker-red',
        '2': 'marker-red',
        '3': 'marker-red',
        '4': 'marker-yellow',
        '5': 'marker-yellow'
      }[index]
    },
    link(cnpj) {
      const params = [
        '/cm-embarcador?',
        'o[]=updated_at',
        'o[]=desc',
        `q[generic]=${cnpj}`,
        `q[period_type]=${this.periodType || 'occurred_at'}`,
        `q[start_date]=${this.startDate}`,
        `q[end_date]=${this.endDate}`
      ]

      params.push(`q[company_status]=${encodeURIComponent(this.companyStatus)}`)

      return params.join('&')
    },
    getBadgeClass(index) {
      if (index <= 3) return 'badge-danger'
      if (index <= 5) return 'badge-warning'
      return 'badge-secondary'
    },
  },
  name: 'Companies',
  props: {
    data: { required: true, type: Array },
    loading: { required: true, type: Boolean },
    endDate: { required: true, type: String },
    startDate: { required: true, type: String },
    periodType: { required: true, type: String },
    companyStatus: { type: String, default: '' }
  }
}
</script>

<style scoped></style>
